import { render, staticRenderFns } from "./iconTwinBeds.vue?vue&type=template&id=fb6a1baa"
import script from "./iconTwinBeds.vue?vue&type=script&lang=js"
export * from "./iconTwinBeds.vue?vue&type=script&lang=js"
import style0 from "./iconTwinBeds.vue?vue&type=style&index=0&id=fb6a1baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports